export default {
  verifying: 'Verifying email address...',
}
